import { Brick, registerBrick } from 'olympe'

export default class SetLocalStorage extends Brick {
  /**
   * Executed every time the brick receives a new trigger event.
   * Note that the method will be executed _even if_ an input (key, value) is undefined.
   *
   * @protected
   * @param {BrickContext} context
   * @param {string} key
   * @param {string} value
   * @param {function()} forwardEvent
   */
  onUpdate(context, [key, value], [forwardEvent]) {
    // Making sure the browser support local storage
    if (typeof Storage !== 'undefined') {
      localStorage.setItem(key, value)
      forwardEvent()
    } else {
      throw new Error(`Your browser does not support the window.localStorage API`)
    }
  }
}

registerBrick('017a1a0c005bdd266d2a', SetLocalStorage)
